export const menuItems = [
    {id: "1", imgCount: "5", name: "Kafe", items: [
        {
            id: "1",
            name: "Domaća kafa",
            price: "150",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Espresso",
            price: "180",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Espresso sa mlekom",
            price: "190",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Dopio",
            price: "360",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Macchiato",
            price: "180",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Cappuccino",
            price: "190",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Mocha",
            price: "230",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Ice mocha",
            price: "230",
            imgUrl: ""
        },
        /*{
            id: "9",
            name: "Ice coffee",
            price: "230",
            imgUrl: ""
        },*/
        {
            id: "9",
            name: "Caffe latte",
            price: "190",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Latte macchiato",
            price: "190",
            imgUrl: ""
        },
        /*{
            id: "12",
            name: "Affogato",
            price: "300",
            imgUrl: ""
        },*/
        {
            id: "11",
            name: "Instant (nes)",
            price: "200",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Instant soja (nes)",
            price: "220",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Mleko dodatak",
            price: "20",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Sojino mleko",
            price: "60",
            imgUrl: ""
        },
        {
            id: "15",
            name: "Krimer mleko",
            price: "30",
            imgUrl: ""
        },
        {
            id: "16",
            name: "Šlag",
            price: "30",
            imgUrl: ""
        },
    ]},
    {id: "2", imgCount: "1", name: "Topli napici", items: [
        {
            id: "1",
            name: "Čaj",
            options: ["Milford nana", "Milford kamilica", "Milford zeleni", "Milford earl grey", "Milford jabuka cimet", "Milford jagoda jogurt"],
            price: "150",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Topla čokolada",
            options: ["crna, bela"],
            price: "220",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Plazma dodatak",
            price: "40",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Oreo mrvice dodatak",
            price: "40",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Kit-ket mrvice dodatak",
            price: "40",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Šlag dodatak",
            price: "30",
            imgUrl: ""
        },
    ]},
    {id: "3", imgCount: "2", name: "Bezalkoholna pića", items: [
        {
            id: "1",
            name: "Coca Cola 0,25l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Coca Cola Zero 0,25l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Fanta 0,25l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Schweppes bitter lemon 0,25l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Schweppes tonic 0,25l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Schweppes tangerine 0,25l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Sprite 0,25l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Ultra 0,25l",
            price: "260",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Next 0,25l",
            options: ["jabuka", "jagoda", "breskva", "narandža", "borovnica"],
            price: "240",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Cedevita",
            options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "150",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Rosa 0,33l",
            options: ["gazirana", "negazirana"],
            price: "160",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Rosa 0,75l",
            options: ["gazirana", "negazirana"],
            price: "280",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Romerquelle 0,33l",
            options: ["limunska trava"],
            price: "230",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Šejk čokolada",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "240",
            imgUrl: ""
        },
        {
            id: "15",
            name: "Šejk vanila",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "240",
            imgUrl: ""
        },
        {
            id: "16",
            name: "Šejk jagoda",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "240",
            imgUrl: ""
        },
        {
            id: "17",
            name: "Šejk oreo",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "300",
            imgUrl: ""
        },
        {
            id: "18",
            name: "Šejk plazma",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "300",
            imgUrl: ""
        },
        /*{
            id: "19",
            name: "Šejk Kit'ket",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "300",
            imgUrl: ""
        },*/
        {
            id: "19",
            name: "Limunada 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "220",
            imgUrl: ""
        },
        {
            id: "20",
            name: "Narandža ceđena 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "280",
            imgUrl: ""
        },
        {
            id: "21",
            name: "Grejp ceđen 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "320",
            imgUrl: ""
        },
        {
            id: "22",
            name: "Citrus miks 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "350",
            imgUrl: ""
        },
        {
            id: "23",
            name: "Ledeni čaj breskva 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "290",
            imgUrl: ""
        },
        /*{
            id: "25",
            name: "Ledeni čaj lubenica 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "290",
            imgUrl: ""
        },*/
        {
            id: "24",
            name: "Ledeni čaj malina 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "290",
            imgUrl: ""
        },
        {
            id: "25",
            name: "Kolektiv miks 0,25l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "290",
            imgUrl: ""
        },
    ]},
    {id: "4", imgCount: "2", name: "Alkoholna pića", items: [
        {
            id: "1",
            name: "Johnnie Walker red label 0,03l",
            price: "220",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Johnnie Walker black label 0,03l",
            price: "300",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Ballantine s finest 0,03l",
            price: "200",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Chivas regal 12YO 0,03l",
            price: "310",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Jameson 0,03l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Jack deniels 0,03l",
            //options: ["Beli eurokrem", "lešnik", "kokos", "slatka pavlaka", "šlag", "karamela"],
            price: "250",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Smirnoff vodka 0,03l",
            //options: ["Nutela", "šlag"],
            price: "200",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Džin Gordon's 0,03l",
            //options: ["Nutela", "plazma", "šlag"],
            price: "200",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Agavita tekila 0,03l",
            //options: ["Bela čokolada", "jagoda", "šlag"],
            price: "180",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Gorki list 0,05l",
            price: "220",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Jeger 0,03l",
            price: "240",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Baileys 0,03l",
            price: "270",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Martini bianco 0,03l",
            price: "220",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Badel Konjak 0,03l",
            price: "200",
            imgUrl: ""
        }
    ]},
    {id: "5", imgCount: "1", name: "Rakije", items: [
        {
            id: "1",
            name: "Zekić Dunja 0,03l",
            //options: ["Tost hleb", "piletina", "pančeta", "jaje", "zelena salata", "paradajz", "pavlaka", "burger sos", "pomfrit"],
            price: "200",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Zekić Šljiva 0,03l",
            //options: ["Tost hleb", "pančeta", "gauda", "jaje", "zelena salata", "paradajz", "pavlaka", "pomfrit"],
            price: "200",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Zekić Kajsija 0,03l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "200",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Zekić Viljamovka 0,03l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "200",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Dedino unuče Barikirana",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "250",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Dedino unuče suva šljiva",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "250",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Dedino unuče šljiva",
            //options: ["kajsija", "šljiva"],
            price: "220",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Dedino unuče kajsija",
            //options: ["kajsija", "šljiva"],
            price: "220",
            imgUrl: ""
        },
    ]},
    {id: "6", imgCount: "1", name: "Vina", items: [
        {
            id: "1",
            name: "Doja Tamjanika 0,7l",
            //options: ["Pene", "pančeta", "neutralna pavlaka", "gauda", "parmezan", "beli luk", "jaja"],
            price: "2300",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Doja merlot & Cabernet Sauvignon 0,7l",
            //options: ["Pene", "dimljena piletina", "neutralna pavlaka", "gordonzola"],
            price: "2500",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Doja Prokupac 0,7l",
            //options: ["Pene", "pršuta", "neutralna pavlaka", "crni luk", "šargarepa", "tikvice", "timijan"],
            price: "2200",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Doja Šardone pinot grigio",
            //options: ["Pirinač", "piletina", "nšargarepa", "kukuruz", "grašak", "pavlaka za kuvanje"],
            price: "2000",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Aleksić Žuti cvet 0,187l",
            //options: ["Pirinač", "šargarepa", "kukuruz šećerac", "grašak", "crni luk", "paradajz sos"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Aleksić Barbara 0,187l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Aleksić Nostalgija 0,187l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "390",
            imgUrl: ""
        },
    ]},
    {id: "7", imgCount: "1", name: "Piva", items: [
        {
            id: "1",
            name: "Carlsberg 0,25l",
            //options: ["Piletina", "pomfrit", "salata mix", "burger sos", "cherry"],
            price: "280",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Tuborg 0,33l",
            //options: ["Piletina", "pomfrit", "salata", "pavlaka za kuvanje"],
            price: "270",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Blanc 0,33l",
            //options: ["Tortilja", "pileće belo meso", "pančeta", "salata", "Cezar dresing", "paradajz"],
            price: "270",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Lav 0,33l",
            //options: ["Piletina", "pršuta", "krem sos", "grilovano povrće", "pekarski krompir"],
            price: "200",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Budweiser 0,33l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "340",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Erdiger 0,33l",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Točeno Blanc",
            options: ["0,3l", "0,5l"],
            price: "320/360",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Točeno Carlsberg",
            options: ["0,3l", "0,5l"],
            price: "320/360",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Somersby",
            options: ["jabuka", "kruška", "borovnica", "mango"],
            price: "320",
            imgUrl: ""
        },
    ]},
    {id: "8", imgCount: "1", name: "Kokteli", items: [
        {
            id: "1",
            name: "Mai Tai",
            options: ["beli rum", "amaretto", "triple sec", "grenadine", "peachtree", "pomorandža", "ananas"],
            price: "550",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Long Island",
            options: ["vodka", "tekila", "triple sec", "džin", "beli rum", "limunov sok", "coca-cola"],
            price: "590",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Blue frog",
            options: ["vodka", "džin", "triple sec", "tekila", "beli rum", "blue coracao", "limunov sok", "guarana"],
            price: "600",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Devil ice tea",
            options: ["vodka", "džin", "triple sec", "tekila", "beli rum", "limunov sok", "sprite", "absiinth", "jelzin"],
            price: "590",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Sex on the beach",
            options: ["peachtree", "vodka", "narandža", "borovnica"],
            price: "500",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Black Sabbath",
            options: ["vodka", "jelzin", "passion fruit", "borovnica", "triplesec"],
            price: "590",
            imgUrl: ""
        },
        /*{
            id: "7",
            name: "Mojito",
            options: ["limun", "nana", "braon šećer", "beli rum", "sprite"],
            price: "550",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Kolektiv",
            options: ["limeta", "jelzin", "borovnica", "malina", "peachtree", "passion fruit", "beli rum"],
            price: "620",
            imgUrl: ""
        },*/
    ]},
    {id: "9", imgCount: "1", name: "Doručak", items: [
        {
            id: "1",
            name: "Omlet sa povrćem",
            options: ["pogačica", "jogurt", "paprika", "pečurke"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Omlet sa sirom",
            options: ["pogačica", "jogurt", "sir"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Omlet sa slaninom",
            options: ["pogačica", "slanina", "pavlaka", "paradajz"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Omlet kačkavalj-šunka",
            options: ["pogačica", "šunka", "kačkavalj", "kajmak"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Kraljevski doručak",
            options: ["300g kobasice", "jaja na oko", "sir", "pogačica", "paprika u pavlaci"],
            price: "790",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Kraljevski doručak - pola porcije",
            options: ["150g kobasice", "jaja na oko", "sir", "pogačica", "paprika u pavlaci"],
            price: "490",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Kolektiv doručak",
            options: ["mekike", "šunka", "pečenica", "kulen", "kajmak", "paradajz"],
            price: "450",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Kačamak",
            options: ["kačamak", "pržena slanina", "sir"],
            price: "340",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Veći pomfrit 300gr",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "310",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Manji pomfrit 150gr",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "160",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Veća porcija pekarskog krompira 300gr",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "310",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Manja porcija pekarskog krompira 150gr",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "160",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Lepinja (kom)",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "50",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Jaje (kom)",
            //options: ["narandža", "limun", "limeta", "zova", "ananas"],
            price: "60",
            imgUrl: ""
        },
    ]},
    {id: "10", imgCount: "1", name: "Salate", items: [
        {
            id: "1",
            name: "Cezar salata",
            options: ["zelena salata", "čeri", "kukuruz", "krutoni", "piletina", "slanina", "dresing", "parmezan"],
            price: "710",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Grčka salata",
            options: ["paradajz", "krastavac", "crveni luk", "paprika", "masline", "feta", "balzamiko"],
            price: "490",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Tuna salata",
            options: ["zelena salata", "čeri", "kukuruz", "crveni luk", "masline", "tuna", " tropski dresing"],
            price: "650",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Kolektiv salata",
            options: ["zelena salata", "čeri", "masline", "seme bundeve", "grilovana dimljena piletina", "parmezan", "susam"],
            price: "750",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Vitaminska salata",
            options: ["zeleni i crveni kupus", "šargarepa", "peršun", "balzamiko", "sok od limuna", "zelena salata", "krastavac"],
            price: "450",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Šopska salata",
            options: ["paradajz", "krastavac", "luk", "sir"],
            price: "510",
            imgUrl: ""
        },
    ]},
    {id: "11", imgCount: "1", name: "Paste", items: [
        {
            id: "1",
            name: "Pasta sa dimljenom piletinom",
            options: ["neutralna pavlaka", "dimljena piletina", "gorgonzola", "vlašac"],
            price: "650",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Fungi pasta",
            options: ["neutralna pavlaka", "pečurke", "beli luk"],
            price: "510",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Tuna pasta",
            options: ["tuna", "kukuruz", "crveni luk", "paprika", "soja sos", "tikvica"],
            price: "610",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Pasta sa pančetom i spanaćem",
            options: ["neutralna pavlaka", "spanać", "beli luk", "mocarela", "parmezan", "pančeta"],
            price: "610",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Pasta sa tikvicama",
            options: ["neutralna pavlaka", "tikvice", "pesto sos", "kikiriki puter", "ananas"],
            price: "510",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Pasta 4 vrste sira",
            options: ["neutralna pavlaka", "parmezan", "mocarela", "gorgonzola", "gauda", "vlašac"],
            price: "650",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Kolektiv pasta",
            options: ["neutralna pavlaka", "pančeta", "kulen", "ruzmarin", "mocarela", "piletina"],
            price: "690",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Pasta piletina i pečurke",
            options: ["neutralna pavlaka", "piletina", "pečurke", "mocarela", "gorgonzola"],
            price: "690",
            imgUrl: ""
        },
    ]},
    {id: "12", imgCount: "1", name: "Sendviči", items: [
        {
            id: "1",
            name: "Sendvič šunka",
            options: ["namaz", "kačkavalj", "šunka", "sveži krastavac", "paradajz", "zelena salata"],
            price: "370",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Sendvič kulen",
            options: ["namaz", "kačkavalj", "kulen", "krastavac", "paradajz", "salata"],
            price: "380",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Sendvič pečenica",
            options: ["namaz", "kačkavalj", "dimljena pečenica", "krastavac", "paradajz", "salata"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Classic sendvič",
            options: ["namaz", "kačkavalj", "svinjska pečenica", "krastavac", "paradajz", "zelena salata"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Tuna sendvič",
            options: ["posni namaz", "posni kačkavalj", "tunjevina", "krastavac", "zelena salata"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Toplički sendvič",
            options: ["kulen", "dimljena pečenica", "jaja", "kačkavalj", "krastavac", "paradajz", "zelena salata", "kajmak"],
            price: "430",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Tost sendvič",
            options: ["hleb", "kačkavalj", "jaje", "svinjska pečenica", "hamburška slanina", "pavlaka"],
            price: "370",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Double cheese",
            options: ["pečenica", "kačkavalj", "gauda", "pavlaka", "pavlaka", "sveži krastavac"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Sendvič sa piletinom",
            options: ["grilovana piletina", "zelena salata", "krastavčići", "cezar dresing"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Kolektiv klub sendvič",
            options: ["njeguška pršuta", "kačkavalj", "gauda", "jaje", "pomfrit", "pavlaka", "kečap"],
            price: "450",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Preklopljeni sendvič piletina",
            options: ["grilovana piletina", "kačkavalj", "ala kajmak", "sveži krastavac", "cezar dresing"],
            price: "490",
            imgUrl: ""
        },
    ]},
    {id: "13", imgCount: "4", name: "Fast food", items: [
        {
            id: "1",
            name: "Cezar burger",
            options: ["zemička", "pileći burger", "zelena salata", "paradajz", "čedar sir", "cezar dresing"],
            price: "590",
            imgUrl: ""
        },
        /*{
            id: "2",
            name: "Tasty burger",
            options: ["zemička", "burger (Angus meso)", "čedar sir", "luk", "zelena salata", "kiseli krastavac", "burger sos"],
            price: "690",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Triplecheese burger",
            options: ["zemička", "burger (Angus meso)", "paradajz", "zelena salata", "kiseli krastavac", "čedar sir", "burger sos"],
            price: "690",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Crispycheese burger",
            options: ["zemička", "burger (Angus meso)", "luk", "paradajz", "zelena salata", "kiseli krastavac", "čedar sir", "burger sos"],
            price: "690",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Vegan burger",
            options: ["zemička", "burger od povrća", "vegan majonez", "paradajz", "zelena salata", "crveni luk", "krastavčići"],
            price: "610",
            imgUrl: ""
        },*/
        {
            id: "2",
            name: "Piletina ananas-mango sos",
            options: ["piletina", "pavlaka", "mango sos", "pekarski krompir"],
            price: "580",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Piletina u kari sosu sa spanaćem",
            options: ["piletina", "spanać", "crveni luk", "kari sos", "pekarski krompir"],
            price: "640",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Piletina sos 4 vrste pečuraka",
            options: ["piletina", "miks pečuraka", "pavlaka", "šampinjoni", "pekarski krompir"],
            price: "680",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Piletina 4 vrste sira",
            options: ["grilovana piletina", "neutralna pavlaka", "gorgonzola", "gauda", "mocarela", "parmezan", "pomfrit"],
            price: "710",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Carski prsti",
            options: ["carski prsti", "pekarski krompir ili pomfrit"],
            price: "590",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Chicken nuggets",
            options: ["chicken nuggets", "pekarski krompir ili pomfrit"],
            price: "590",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Tortilja sa piletinom",
            options: ["grilovana piletina", "tarator sos", "zelena salata", "paradajz", "pomfrit"],
            price: "470",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Tortilja sa slaninom",
            options: ["slanina", "krem sir", "rukola", "pesto sos", "paradajz", "pomfrit", "kečap"],
            price: "520",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Kobasica u lepinji",
            options: ["kobasica", "lepinja", "kajmak", "pomfrit"],
            price: "750",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Kobasica u lepinji - pola porcije",
            options: ["kobasica", "lepinja", "kajmak", "pomfrit"],
            price: "470",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Kobasica, paprika u pavlaci, pomfrit ili pekarski",
            options: [],
            price: "730",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Kobasica, paprika u pavlaci, pomfrit ili pekarski - pola porcije",
            options: [],
            price: "460",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Pomfrit sa čedar sosom - veća porcija",
            options: [],
            price: "410",
            imgUrl: ""
        },
        {
            id: "15",
            name: "Pomfrit sa čedar sosom - manja porcija",
            options: [],
            price: "320",
            imgUrl: ""
        },
    ]},
    {id: "14", imgCount: "1", name: "Pice", items: [
        {
            id: "1",
            name: "Margarita",
            options: ["pelat", "kačkavalj", "*može biti posna"],
            price: "740/1350",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Capricosa",
            options: ["pelat", "šunka", "kačkavalj", "pečurke"],
            price: "850/1550",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Kolektiv",
            options: ["pelat", "kačkavalj", "piletina", "pečurke", "jaje", "pavlaka"],
            price: "870/1590",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Bosanska",
            options: ["pelat", "šunka", "kačkavalj", "pečurke", "pečenica", "kulen", "pančeta", "jaje"],
            price: "970/1790",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Calabrese",
            options: ["pelat", "kačkavalj", "pečurke", "suvi vrat", "hamburška slanina", "parmezan", "masline", "papričice"],
            price: "960/1740",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Fungi",
            options: ["pelat", "kačkavalj", "pečurke", "*može biti posna"],
            price: "710/1290",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Gurmanska",
            options: ["pelat", "pečenica", "pančeta", "kačkavalj", "jaje", "pavlaka", "masline"],
            price: "880/1610",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Tuna",
            options: ["pelat", "posni kačkavalj", "tuna", "kukuruz", "crveni luk", "rukola", "masline crne", "*može biti posna"],
            price: "880/1590",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Mađarica",
            options: ["pelat", "kačkavalj", "pečenica", "kulen", "pančeta", "feferoni", "susam"],
            price: "890/1650",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Quatro formaggi",
            options: ["pelat", "kačkavalj", "gorgonzola", "dimljeni sir", "parmezan"],
            price: "960/1750",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Vegeterijana",
            options: ["pelat", "kačkavalj", "tikvica", "crvena paprika", "kukuruz", "pečurke", "*može biti posna"],
            price: "780/1280",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Piroška",
            options: ["pavlaka", "kačkavalj", "šunka", "pečurke", "pelat", "pavlaka", "kečap"],
            price: "660",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Diavolo",
            options: ["kačkavalj", "pečurke", "kulen", "seckane papričice", "crveni luk"],
            price: "810/1480",
            imgUrl: ""
        },
    ]},
    {id: "15", imgCount: "1", name: "Palačinke slane", items: [
        {
            id: "1",
            name: "Standard palačinka",
            options: ["šunka", "kačkavalj", "pavlaka"],
            price: "440",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Palačinke sa piletinom",
            options: ["piletina", "krastavčići", "šunka", "pavlaka", "majonez", "senf"],
            price: "520",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Popaj palačinka",
            options: ["spanać", "feta sir", "pečenica"],
            price: "520",
            imgUrl: ""
        },
        /*{
            id: "4",
            name: "Vegan palačinka",
            options: ["krompir", "šargarepa", "paprika", "ljuta papričica", "crveni luk", "pavlaka"],
            price: "",
            imgUrl: ""
        },*/
        {
            id: "4",
            name: "Kolektiv palačinka",
            options: ["pančeta", "kačkavalj", "mocarela", "pečenica", "pavlaka", "majonez", "rukola"],
            price: "560",
            imgUrl: ""
        },
    ]},
    {id: "16", imgCount: "6", name: "Palačinke slatke", items: [
        {
            id: "1",
            name: "Palačinka sa džemom",
            options: ["šipurak", "jagoda", "kajsija"],
            price: "310",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Palačinka sa medom i orasima",
            options: ["med", "orah"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Palačinka eurokrem",
            options: ["eurokrem"],
            price: "350",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Palačinka eurokrem-plazma",
            options: ["eurokrem", "plazma"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Palačinka eurokrem-plazma-banana",
            options: ["eurokrem", "plazma", "banana"],
            price: "410",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Palačinka nutela",
            options: ["nutela"],
            price: "440",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Palačinka nutela-plazma",
            options: ["nutela", "plazma"],
            price: "460",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Palačinka nutela-plazma-banana",
            options: ["nutela", "plazma", "banana"],
            price: "480",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Palačinka nutela-višnja",
            options: ["nutela", "nadev višnja", "plazma"],
            price: "560",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Palačinka nutela-vanila",
            options: ["nutela", "vanila krem", "sos voćni"],
            price: "480",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Vanila plazmino",
            options: [],
            price: "510",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Rafaelo",
            options: ["rafaelo", "kokos", "badem", "sladoled"],
            price: "540",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Bela pistaći",
            options: ["bela čokolada", "pistaći krem"],
            price: "540",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Bela nutela",
            options: ["nutela", "bela čokolada"],
            price: "560",
            imgUrl: ""
        },
        {
            id: "15",
            name: "Nutela pistaći",
            options: ["nutela", "pistaći krem"],
            price: "560",
            imgUrl: ""
        },
        {
            id: "16",
            name: "Nutela pistaći malina",
            options: ["nutela", "pistaći krem", "malina"],
            price: "580",
            imgUrl: ""
        },
        {
            id: "17",
            name: "Kapri",
            options: ["bela čokolada", "voćni krem", "kokos"],
            price: "510",
            imgUrl: ""
        },
        {
            id: "18",
            name: "Jafa",
            options: ["nutela", "nadev narandža", "plazma", "čokoladni preliv"],
            price: "480",
            imgUrl: ""
        },
        {
            id: "19",
            name: "Plazmino",
            options: ["plazma", "mleko", "nutela"],
            price: "480",
            imgUrl: ""
        },
        {
            id: "20",
            name: "Kolektiv",
            options: ["nutela", "bela čokolada", "sladoled", "lešnik"],
            price: "580",
            imgUrl: ""
        },
        {
            id: "21",
            name: "Oreo palačinka",
            options: ["oreo mrvice, bela čokolada, nutela"],
            price: "560",
            imgUrl: ""
        },
        {
            id: "22",
            name: "Kit-ket palačinka",
            options: [],
            price: "650",
            imgUrl: ""
        },
        {
            id: "22",
            name: "Američke palačinke",
            options: ["*nutela-plazma-čokoladni preliv"],
            price: "550",
            imgUrl: ""
        },
        {
            id: "23",
            name: "Američke palačinke",
            options: ["*nutela-plazma-banana-čokolada preliv"],
            price: "550",
            imgUrl: ""
        },
        {
            id: "24",
            name: "Američke palačinke",
            options: ["*nutela-lešnik-karamel preliv"],
            price: "550",
            imgUrl: ""
        },
        {
            id: "25",
            name: "Američke palačinke",
            options: ["*vanila krem-miks voća-voćni preliv"],
            price: "550",
            imgUrl: ""
        },
        {
            id: "26",
            name: "Američke palačinke",
            options: ["*vanila krem-plazma-čokolada preliv"],
            price: "550",
            imgUrl: ""
        },
    ]},
    /*{id: "17", imgCount: "1", name: "Pice slatke", items: [
        {
            id: "1",
            name: "Nutela pica",
            options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "550/980",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Kolektiv slatka pica",
            options: ["vanila krem", "neutralna pavlaka", "miks voća", "voćni preliv"],
            price: "580/1000",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Bella pica",
            options: ["neutralna pavlaka", "vanila krem", "lešnik", "toping"],
            price: "540/940",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Lešnik pica",
            options: ["neutralnog pavlaka", "nutela", "lešnik", "karamel preliv"],
            price: "550/980",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Plazmino pica",
            options: ["plazma", "mleko", "slatki namaz", "banana", "voćni preliv", "čokoladni preliv"],
            price: "550/980",
            imgUrl: ""
        },
    ]},*/
    /*{id: "18", name: "Sladoled", items: [
        {
            id: "1",
            name: "Sladoled standard čokolada kugla",
            //options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "130",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Sladoled standard vanila - kugla",
            //options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "130",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Sladoled standard jogurt-višnja - kugla",
            //options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "130",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Sladoled standard malaga - kugla",
            //options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "130",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Sladoled standard oreo - kugla",
            //options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "130",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Sladoled premium cherry mania - kugla",
            //options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "150",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Sladoled premium kinder bueno - kugla",
            //options: ["nutela", "neutralna pavlaka", "plazma", "sezonsko voće", "toping"],
            price: "150",
            imgUrl: ""
        },
    ]}, */
    {id: "18", imgCount: "1", name: "Kupovi", items: [
        {
            id: "1",
            name: "Kolektiv kup",
            options: ["vanila krem", "beli krem", "plazma", "borovnica", "malina", "šlag"],
            price: "520",
            imgUrl: ""
        },
    ]},
    {id: "19", imgCount: "0", name: "Domaći kolači", items: [
        {
            id: "1",
            name: "Žito kuvano sa i bez šlagom",
            options: ["orah", "šećer u prahu", "pšenica", "šećer"],
            price: "300",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Reforma torta",
            options: ["brašno", "jaja", "menaz čokolada", "orah", "šlag"],
            price: "360",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Keks kolač",
            options: ["keks", "mleko", "griz", "jaja"],
            price: "310",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Ruska kapa",
            options: ["brašno", "jaja", "menaz čokolada", "kokos"],
            price: "290",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Ekler",
            options: ["menaz čokolada", "mleko", "brašno", "jaja"],
            price: "280",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Ledena kocka",
            options: ["menaz čokolada", "mleko", "brašno", "jaja"],
            price: "300",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Čoko rol baklava",
            options: ["čokolada", "plazma", "šećer"],
            price: "300",
            imgUrl: ""
        },
    ]},
];